import React, { useContext, useState } from "react";
import { ReactComponent as WhatsappIcon } from "../../assets/icons/whatsapp-filled.svg";
import { ReactComponent as MailIcon } from "../../assets/icons/mail-filled.svg";
import { ReactComponent as RefreshIcon } from "../../assets/icons/refresh-filled.svg";
import { ReactComponent as QuestionIcon } from "../../assets/icons/question-filled.svg";
import FloatingLabelInput from "../../Components/FloatingLabelInput";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { getFullHttpUrl } from "../../firebase.config";
import { EAST1, EAST4 } from "../../utility/enums";

const SupportSection = ({ windowSize }) => {
  const { showNotification } = useContext(NotificationContext);
  const { userData } = useContext(DataContext);

  const { transitionTo } = useScreenTransition();

  const [submitButton, setSubmitButton] = useState("Submit");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [businessType, setBusinessType] = useState("person");
  const [businessName, setBusinessName] = useState("");
  const [phone, setPhone] = useState("");
  const [expectedVolume, setExpectedVolume] = useState("");
  
  const handleSubmit = () => {
    setSubmitButton("Submitting...");

    const data = {
      name: name,
      email: email.toLowerCase(),
      message: message,
    }
    if (businessType === "business") {
      data.businessName = businessName;
      data.phone = phone;
      data.expectedVolume = expectedVolume;
      data.translationNeeds = message;
    }

    axios({
      method: "post",
      url: getFullHttpUrl(businessType === "business" ? "businessFormSubmitted" : "contactFormSubmitted", EAST4),
      data: {
        ...data,
      },
    })
      .then((response) => {
        setName("");
        setEmail("");
        setMessage("");
        setBusinessName("");
        setPhone("");
        setExpectedVolume("");
        setSubmitButton("Submit");
        showNotification(
          "Success",
          "Your message was successfully sent to our Support team.",
          "success"
        );
      })
      .catch((error) => {
        setSubmitButton("Submit");
        showNotification(
          "Error",
          "An error ocurred sending your message. Please, try again. If it persists, contact technical support at support@everbary.com",
          "error"
        );
      });
  };
  const isFormValid = () => {
    return (
        name !== "" &&
      message !== "" &&
      /^[\w-\.]+@[\w-]+\.[a-z]{2,7}$/.test(email) &&
      (businessType === "business" ? (businessName !== "" && phone !== "" && expectedVolume !== "") : true)
    );
  };


  return (
    <div
      className="w-full grid gap-5 md:grid-cols-2 grid-cols-1 mt-5"
      id="support"
    >
      <div className="bg-white rounded-4xl p-8 shadow-md ">
        <div className="flex flex-col gap-4">
          <h2 className="md:text-5xl text-4xl text-tertiary font-medium uppercase">
            Support
          </h2>
          <h2 className="text-2xl font-medium mt-4">
            8 AM - 11 PM EST
            {windowSize.width < 1024 && <br />}
            <span className="text-[#686F7B] text-base">
              (After hours for urgent matters)
            </span>
          </h2>
        </div>
        <div className="flex flex-col gap-4 mt-4">
          <button className="text-primary text-base font-medium flex gap-2 items-center" onClick={() =>
            window.open(
              "mailto:support@everbary.com",
              "_blank"
            )
          }>
            <MailIcon className="h-6 w-6" /> support@everbary.com
          </button>
          <button
            className="text-primary text-base font-medium flex gap-2 items-center"
            onClick={() =>
              window.open(
                "https://wa.me/15059168399/?text=Hello!%20I%20am%20reaching%20out%20to%20you%20because%20",
                "_blank"
              )
            }
          >
            <WhatsappIcon className=" h-6 w-6" /> WhatsApp
            <span className="text-[#686F7B] text-base">
              {windowSize.width < 1024
                ? "(For faster replies)"
                : "(Recommended for faster replies)"}
            </span>
          </button>
        </div>
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl font-medium mt-4">Useful links</h2>
          <button
            className="text-primary text-base font-medium flex gap-2 items-center"
            onClick={() => transitionTo("/order-lookup")}
          >
            <RefreshIcon className="h-6 w-6" />
            Order Status
          </button>
          <button
            className="text-primary text-base font-medium flex gap-2 items-center"
            onClick={() => transitionTo("/faq")}
          >
            <QuestionIcon className="h-6 w-6" />
            F.A.Q.
          </button>
        </div>
      </div>

      <div className="bg-tertiary rounded-4xl p-8">
        <h1 className="md:text-5xl text-4xl text-white font-medium uppercase mb-6">
          Contact us
        </h1>
        <div className="flex flex-col space-y-4 ">
          <select className="block p-3 w-full text-base text-white bg-tertiary border border-gray-700 rounded-md focus:outline-none focus:ring-0 peer placeholder-transparent"
            value={businessType}
            onChange={(e) => setBusinessType(e.target.value)}
          >
            <option value="person">Person</option>
            <option value="business">Business</option>
          </select>
          <FloatingLabelInput
            type={"text"}
            label={"Name"}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {businessType === "business" && <FloatingLabelInput
            type={"text"}
            label={"Business Name"}
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
          />}
          <FloatingLabelInput
            type={"text"}
            label={"Email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {businessType === "business" && <FloatingLabelInput
            type={"text"}
            label={"Phone"}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />}
          {businessType === "business" && <FloatingLabelInput
            type={"text"}
            label={"Expected Volume"}
            value={expectedVolume}
            onChange={(e) => setExpectedVolume(e.target.value)}
          />}
          <div className="relative w-full">
            <textarea
              id="floating_textarea"
              placeholder=" "
              rows="4"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="block p-3 pt-5 w-full text-base text-white bg-tertiary border border-gray-700 rounded-md focus:outline-none focus:ring-0 peer placeholder-transparent"
            />
            <label
              htmlFor="floating_textarea"
              className="absolute text-base text-white duration-300 transform -translate-y-4 bg-tertiary top-2 left-3 z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5"
            >
              {businessType === "business" ? "Describe your translation needs" : "Message"}
            </label>
          </div>

          <button
            onClick={handleSubmit}
            disabled={!isFormValid()}
            className={`mt-4 p-3 text-white font-semibold rounded-full transition-colors ${
              isFormValid()
                ? "bg-primary hover:bg-cyan-600"
                : "bg-gray-400 cursor-not-allowed"
            } `}
          >
            {submitButton !== "Submitting..." ? submitButton : "Submitting, Please wait"}
            {submitButton === "Submitting..." && <span className="dotsLoading">...</span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;
